import { customizeSearch, createCustomToggle, fixFeatureButton } from './helpers';

$(document).ready(function () {
  // Prepend General Message Banner to Header
  $('.generalmessage').prependTo('header');
  customizeSearch();
  createCustomToggle();
  fixFeatureButton();
});

$(globalThis).on('pageshow', function () {
  $(globalThis).scrollTop(0);
});
